import React, { useState, useContext } from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Paper,
    TextField,
    Grid,
    withStyles,
    InputLabel
} from '@material-ui/core';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import { TextBox } from '../../../../Core/FormInput';
import formatters from './../../../../Core/Grid/inputFormatter';
import { SimpleField } from './../../../../Core/FormInput/inputfields';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px 6px',
        fontWeight: 700,
        background: 'grey',
        textTransform: 'uppercase',
        color: 'white',
        border: '1px solid'
    },
    body: {
        fontSize: 12,
        padding: '4px'
        // border: 'none'
    }
}))(TableCell);
const StyledTotalTableCell = withStyles((theme) => ({
    body: {
        background: 'white',
        padding: '4px',
        fontWeight: 600,
        fontSize: 13
        // color: 'white'
        // border: 'none'
    }
}))(TableCell);

const AccountCodeHistory = ({ accountData, state }) => {
    const { accountCodes } = useContext(BranchFranchiseCompareContext);
    const [filter, setFilter] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const filteredRows = accountCodes.filter((row) =>
        Object.values(row).some((value) => value != null && value.toString().toLowerCase().includes(filter.toLowerCase()))
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const calculateTotal = (key) => {
        return filteredRows.reduce((total, row) => total + (parseFloat(row[key]) || 0), 0);
    };

    const totalFB = calculateTotal('fb');
    const totalCP = calculateTotal('cp');
    const totalCFB = calculateTotal('cfb');
    const totalFP = calculateTotal('fp');

    return (
        <div style={{ padding: 1 }}>
            <Grid container spacing={2}>
                <Grid item xs sm md={12}>
                    <Grid container spacing={2} justifyContent="space-between">
                        {/* <Grid item xs={12} sm={4} md={3} lg={3}>
                            <div style={{ width: '100%', fontSize: 12 }}>Name</div>
                            <div style={{ width: '100%', fontSize: 15, fontWeight: 600 }}> {accountData.catName || 'N/A'}</div>
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={3} lg={2}>
                            <div style={{ width: '100%', fontSize: 12 }}>Branch</div>
                            <div style={{ width: '100%', fontSize: 15, fontWeight: 600 }}> {accountData.branch || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} lg={2}>
                            <div style={{ width: '100%', fontSize: 12 }}>Franchise</div>
                            <div style={{ width: '100%', fontSize: 15, fontWeight: 600 }}> {accountData.franchise || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} lg={2}>
                            <div style={{ width: '100%', fontSize: 12 }}>Year</div>
                            <div style={{ width: '100%', fontSize: 15, fontWeight: 600 }}> {state.yearID || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} lg={2}>
                            <div style={{ width: '100%', fontSize: 12 }}>Period</div>
                            <div style={{ width: '100%', fontSize: 15, fontWeight: 600 }}> {accountData.period || 'N/A'}</div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs sm md={6}>
                    <TextBox placeholder="Search" onChange={(e) => setFilter(e.target.value)} />
                </Grid>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Account Code</StyledTableCell>
                                    <StyledTableCell>Brought Forward</StyledTableCell>
                                    <StyledTableCell>Current Postings</StyledTableCell>
                                    <StyledTableCell>Carry Forward</StyledTableCell>
                                    <StyledTableCell>Future Postings</StyledTableCell>
                                    <StyledTableCell>Expense Group</StyledTableCell>
                                    <StyledTableCell>Expense Category</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length > 0 ? (
                                <TableBody>
                                    {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                        <StyledTableRow key={row.id}>
                                            <StyledTableCell>{row.ac}</StyledTableCell>
                                            <StyledTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(row.fb)}</StyledTableCell>
                                            <StyledTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(row.cp)}</StyledTableCell>
                                            <StyledTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(row.cfb)}</StyledTableCell>
                                            <StyledTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(row.fp)}</StyledTableCell>
                                            <StyledTableCell>{row.egn}</StyledTableCell>
                                            <StyledTableCell>{row.en}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                    <StyledTableRow>
                                        <StyledTotalTableCell align="left" colSpan={1}>
                                            Total
                                        </StyledTotalTableCell>
                                        <StyledTotalTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(totalFB)}</StyledTotalTableCell>
                                        <StyledTotalTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(totalCP)}</StyledTotalTableCell>
                                        <StyledTotalTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(totalCFB)}</StyledTotalTableCell>
                                        <StyledTotalTableCell align="right">{formatters.CurrencyThousandSeparatorWithoutZero(totalFP)}</StyledTotalTableCell>
                                        <StyledTotalTableCell colSpan={2}></StyledTotalTableCell> {/* Empty columns for Expense Group and Category */}
                                    </StyledTableRow>
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell align="center" colSpan={7}>
                                            No Record found{' '}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default AccountCodeHistory;
